import styled from 'styled-components';
import { BaseSection } from '../components/styles';

export const Container = styled.div`
  position: relative;
  #id-homepage-insurer-image-1 {
    object-fit: cover;
    object-position: 7%;
  }
  #id-homepage-insurer-image-2 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-insurer-image-3 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-insurer-image-4 {
    object-fit: cover;
    object-position: 30%;
  }
  #id-homepage-insurer-image-5 {
    object-fit: cover;
    object-position: 90%;
  }
`;

export const FirstSection = styled(BaseSection)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.white};
  text-align: left;
  padding-top: 6rem;

  > button {
    align-items: center;
  }

  > div {
    gap: 1rem;
  }
`;

export const TitleSection = styled.div`
  color: #3f5ec9;
`;

export const ImageLine = styled.img`
  position: absolute;
  margin: 1rem 0;
  width: 530px;
  top: 245px;
  left: 1280px;
`;

